import { UserConditionTypeModel } from './userConditionTypeModel'

export class UserConditionListFilterModel {
    public userConditionType: UserConditionTypeModel;
    public startDate: string;
    public endDate: string;
}